import React from 'react';

import './style.css';

const ExternalLink = ({ profile, icon, href }) => (
    <h5 className='external-link'>
        <a href={href}>
        <i className={'fab fa-'+icon}></i> @{profile}
        </a>
    </h5>
);

export default ExternalLink;


// WEBPACK FOOTER //
// ./src/components/ExternalLink/index.js